
(function(){
  const ORDER = [2, 1, 3, 4, 6, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];   // old row index in new position; owner 2026-10-19 "remove the top row of our page" (old row 0 dropped)
  const rows = [...document.querySelectorAll('section.tiles-section')];
  if (rows.length !== ORDER.length + 1) return;                       // base page changed: leave the order alone
  const anchor = rows[0].previousElementSibling, parent = rows[0].parentNode;
  parent.insertBefore(rows[ORDER[0]], rows[0]);
  ORDER.slice(1).reduce((prev, k) => { prev.after(rows[k]); return rows[k]; }, rows[ORDER[0]]);
  rows[0].remove();
  // owner 2026-10-19: "let's start with first two rows being all Dog Outfits (so 8)" -- 4 more outfits (tiles built by
  // build_extra_dog_outfit_tiles.py) as a second row under the first Dog Outfit row.
  const EXTRA = [['oc-chef_billy-rp', 'The Chef'], ['oc-angel_moose-rp', 'The Angel'], ['oc-sailor_ham-rp', 'The Sailor'], ['oc-cowgirl_malti-rp', 'The Cowgirl']];
  const first = rows[ORDER[0]], row2 = first.cloneNode(true);
  row2.querySelectorAll('figure.tile').forEach((f, i) => {
    const [key, name] = EXTRA[i], img = f.querySelector('img');
    img.src = 'https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/' + key + '-800.webp';
    img.srcset = 'https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/' + key + '-800.webp 800w, https://pocketry-site-media-744329357706.us-west1.run.app/shoot-sofia/' + key + '-1600.webp 1600w';
    img.alt = name + ' - Dog Portrait - Pocketry panel with the original photo';
    f.querySelector('.tile__cap').textContent = name + ' - Dog Portrait';
  });
  row2.querySelectorAll('.tiles-head').forEach(h => h.remove());
  first.after(row2);
  // owner 2026-10-19: "in the dog portrait series section ... eliminate 4 of those and get down to just two rows" -> 8 tiles,
  // each row mixing the 3 styles (dropped: the three Lucys + Fashion Name Monty).
  const DOGS2 = [['04-ham-rp', '03-pets_warren-rp', '01-pets_leo-rp', '03-pet-pairs_cava-malti-rp'],
                 ['01-pet-pairs_monty-malti-rp', '04-milton-rp', 'synth-iw-dog-guapo-ham-teal', '01-pet-pairs_luke-moose-rp']];
  const dogRows = [rows[1], rows[3], rows[4]], figs = {};
  dogRows.forEach(r => r.querySelectorAll('figure.tile').forEach(f => {
    const m = (f.querySelector('img').getAttribute('src') || '').match(/([^/]+)-800\.webp$/); if (m) figs[m[1]] = f; }));
  if (DOGS2.flat().every(k => figs[k]) && !(window.PK_PAGE || {}).series) {   // homepage only: a sub-page needs every dog tile
    [rows[1], rows[3]].forEach((r, i) => { const box = r.querySelector('.tiles'); box.replaceChildren(...DOGS2[i].map(k => figs[k])); });
    rows[4].remove();
  }
})();
